import { faGift } from '@fortawesome/free-solid-svg-icons'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { Roles } from '@/auth/azure/Roles'
import { TileRoleRoute } from '@/types'
import { Incentivi } from '@/routes/admin/autodesk/pages/Incentivi'

export const IncentiviRoute = {
  path: 'incentivi',
  text: 'Incentivi',
  element: <Incentivi />,
  mainMenuRoute: false,
  faIcon: faGift,
  errorElement: <RouterErrorHandler />,
  handle: {
    crumb: () => ({
      label: 'Incentivi',
      icon: faGift,
    }),
  },
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
} satisfies TileRoleRoute
